function VisitsIcon({color = '#000'}: { color?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke={color} strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 7.5H7C6.60218 7.5 6.22064 7.65804 5.93934 7.93934C5.65804 8.22064 5.5 8.60218 5.5 9V17C5.5 17.3978 5.65804 17.7794 5.93934 18.0607C6.22064 18.342 6.60218 18.5 7 18.5H15C15.3978 18.5 15.7794 18.342 16.0607 18.0607C16.342 17.7794 16.5 17.3978 16.5 17V12" />
            <path d="M12.5 11.5L18.864 5.136M14.5 4.5H19.5V9.5" />
        </svg>
    );
}

export default VisitsIcon;
